import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTabContext } from '../TabContext';
export default function DTabContent({ tab, children, className, style, }) {
    const { isSelected } = useTabContext();
    if (!isSelected(tab)) {
        return null;
    }
    return (_jsx("div", { className: classNames('tab-pane fade show active', className), id: `${tab}Pane`, role: "tabpanel", tabIndex: 0, "aria-labelledby": `${tab}Tab`, style: style, children: children }));
}
//# sourceMappingURL=DTabContent.js.map